import { stylesheet } from "typestyle";

const styles = stylesheet({
  container: {},
});

export default styles;
